import { Banner } from 'breadcrumbs-ui/components/Banner';
import { Text } from 'breadcrumbs-ui/components/Text';
import { useCallback, useEffect, useState } from 'react';
import { updateRootnavComponentDimension } from '../../../NavLayoutDimensions/utils/updateRootnavComponentDimension';
import { useAppDispatch } from '../../../hooks';
import { getSandboxSelfData } from '../api/cachedFetchers';
import { SANDBOX_BANNER_ID, SANDBOX_TYPE, SANDBOX_VERSION } from '../constants/constants';
import { KBLink } from './KBLink';
import { SetUpDeployLink } from './SetUpDeployLink';
import { Logger } from 'simple-logging-lib';
import { UNIFIED_NAVIGATION_UI_LOGGER_NAME } from '../../../constants/logging';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SandboxBanner() {
  const dispatch = useAppDispatch();
  // TODO: fix all translation files
  const [isLoading, setIsLoading] = useState(true);
  const [sandboxSelfData, setSandboxSelfData] = useState(null);
  const {
    type,
    version,
    parentHubId,
    sandboxHubId
  } = sandboxSelfData || {};
  const deployingEnabled = type === SANDBOX_TYPE.STANDARD && version === SANDBOX_VERSION.V2;
  const setSandboxBannerRef = useCallback(el => {
    const height = el ? el.getBoundingClientRect().height : 0;
    updateRootnavComponentDimension('SandboxBanner', {
      height
    }, dispatch);
  }, [dispatch]);
  useEffect(() => {
    getSandboxSelfData().then(sandboxData => {
      setSandboxSelfData(sandboxData);
      setIsLoading(false);
    }).catch(cause => {
      const logger = Logger.getLogger(UNIFIED_NAVIGATION_UI_LOGGER_NAME);
      logger.error(new Error('Failed to fetch sandbox self data', {
        cause
      }));
    });
  }, []);
  return /*#__PURE__*/_jsx(Banner, {
    ref: setSandboxBannerRef,
    id: SANDBOX_BANNER_ID,
    isLoading: isLoading,
    title: /*#__PURE__*/_jsx(Text, {
      typography: "heading-25",
      color: "text-core-default",
      children: type === SANDBOX_TYPE.DEVELOPER ? 'Development Sandbox' : type === SANDBOX_TYPE.STANDARD ? 'Standard Sandbox' : 'Sandbox'
    }),
    actions: deployingEnabled && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(KBLink, {}), /*#__PURE__*/_jsx(SetUpDeployLink, {
        parentHubId: parentHubId !== null && parentHubId !== void 0 ? parentHubId : null,
        sandboxHubId: sandboxHubId !== null && sandboxHubId !== void 0 ? sandboxHubId : null
      })]
    })
  });
}